import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp, Label } from "./Primitives";
import { MANIFESTO, IMAGES } from "../data/content";

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      id="about"
      data-testid="about"
      ref={ref}
      className="relative mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-36"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        {/* Sticky image column */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <FadeUp>
              <div className="relative h-[420px] md:h-[560px] w-full overflow-hidden border border-white/8">
                <motion.img
                  style={{ y }}
                  src={IMAGES.aboutStatue}
                  alt="Veiled marble statue in crimson light"
                  className="absolute inset-0 h-[120%] w-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6">
                  <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/50">
                    Fig. 01 — The Observer
                  </p>
                </div>
              </div>
            </FadeUp>
          </div>
        </div>

        {/* Manifesto chapters */}
        <div className="lg:col-span-7 lg:pl-8">
          <FadeUp className="mb-12">
            <Label>The Manifesto</Label>
            <h2 className="mt-4 font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
              We Are Not <br />
              Our <span className="text-crimson italic">Thoughts.</span>
            </h2>
          </FadeUp>

          <div className="space-y-14">
            {MANIFESTO.map((m, i) => (
              <FadeUp key={m.n} delay={i * 0.08}>
                <div className="border-t border-white/8 pt-8">
                  <div className="flex items-baseline gap-6">
                    <span className="font-mono-accent text-sm text-crimson">
                      {m.n}
                    </span>
                    <div>
                      <h3 className="font-display text-3xl md:text-4xl tracking-tight mb-4">
                        {m.title}
                      </h3>
                      <p className="text-white/55 text-base md:text-lg leading-relaxed max-w-xl">
                        {m.body}
                      </p>
                    </div>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
